import React, {useState} from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';
import { Link as LinkScroll } from 'react-scroll';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { HashLink } from 'react-router-hash-link';
import useMediaQuery from '@material-ui/core/useMediaQuery';

//const role = 'lawyer';

const useStyles = makeStyles({
  optionMenu: {
    textDecoration: 'none',
    color: '#969696',
    '&:hover': {
      color: '#484848',
      backgroundColor: 'rgba 53 185 182, 0.1',
    },
  },
  listItemButton: {
    //color: '#484848',
    border: 'none',
    backgroundColor: 'transparent',
    //padding: 0,
    '&:hover': {
      backgroundColor: 'rgba(53, 185, 182, 0.1)',
    },
  },
  listItemSelected: {
    backgroundColor: 'rgba(53, 185, 182, 0.4) !important',
    color: '#484848',
  },
});

const ITEM_HEIGHT = 48;

function TopNav({ role, community, props, idLawFirm }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [active, setActive] = useState(0);

  //console.log('selected',selectedIndex);
  //console.log('active',active);

  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = open ? 'simple-popover' : undefined;

  const classes = useStyles(props);
  const smallDisplay = useMediaQuery('(max-width: 600px)');

  const options = [
    {
      name: 'Apariencia',
      to: 'look',
      duration: 500,
    },
    idLawFirm
      ? {
          name: 'Titular del despacho',
          to: 'premiumMainHolder',
          duration: 500,
        }
      : null,
    role === 'lawFirm'
      ? {
          name: 'Sobre el despacho',
          to: 'about',
          duration: 500,
        }
      : null,
    role === 'lawFirm'
      ? {
          name: 'Áreas de práctica',
          to: 'specialty',
          duration: 500,
        }
      : null,
    {
      name: 'Experiencia',
      to: 'expertise',
      duration: 500,
    },
    
    role === 'lawyer'
      ? {
          name: 'Sobre ti',
          to: 'about',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Áreas de práctica',
          to: 'specialty',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Educación',
          to: 'education-lawyer',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Cursos y diplomados',
          to: 'courses-lawyer',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Certificaciones',
          to: 'certification',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Premios',
          to: 'award',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Publicaciones',
          to: 'publication',
          duration: 500,
        }
      : null,
    role === 'lawyer'
      ? {
          name: 'Experiencia laboral',
          to: 'laboral',
          duration: 500,
        }
      : null,
    {
      name:'Información',
      to: 'contact',
      duration: 500,
    }, 
    {
      name: 'Redes sociales',
      to: 'socialNetworks',
      duration: 500,
    },
    role === 'lawFirm'
      ? {
          name: 'Titular',
          to: 'addHolder',
          duration: 500,
        }
      : null,
    role === 'lawFirm'
      ? {
          name: 'Equipo',
          to: 'add',
          duration: 500,
        }
      : null,
    {
      name: role === 'lawFirm' ? 'Sedes' : 'Sede' ,
      to: 'site',
      duration: 500,
    },
    {
      name: 'Horarios',
      to: 'schedule',
      duration: 500,
    },
    {
      name: 'Costos',
      to: 'cost',
      duration: 500,
    },
    {
      name: 'Comunidad',
      to: 'communitySection',
      duration: 500,
    },
    community === true ?
    {
      name: 'Tiempo de respuesta',
      to: 'responseTime',
      duration: 500,
    } :
    null,
    {
      name: 'Fotografías',
      to: 'picture',
      duration: 500,
    },
    {
      name: 'Videos',
      to: 'videoProf',
      duration: 500,
    },
    {
      name: 'Compartir',
      to: 'share',
      duration: 500,
    },
  ];

  return (
    <div
      style={{
        height: 55,
        backgroundColor: '#ffffff',
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)'
      }}
    >
      <span style={{ color: '#484848', fontWeight: 'bold', marginLeft: 24 }}>
        Opciones de perfil
      </span>
      <IconButton
        //aria-label="more"
        //aria-controls="long-menu"
        aria-haspopup="true"
        aria-describedby={id} 
        variant="contained"
        onClick={handleClick}
      >
        <MoreVertIcon htmlColor="#013957" />
      </IconButton>
      <Popover
        id={id}
        //elevation={0}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 200,
            //top: 330
          },
        }}
      >
        {options.map((option, index) => {
          if (option === null) {
            return null;
          }
          return (
            <LinkScroll
              key={index}
              to={option.to}
              smooth="true"
              duration={500}
              //delay={100}
              offset={smallDisplay? -111:-119}
              className={classes.optionMenu}
              spy={true}
              onSetActive={() => {setSelectedIndex(index); setActive(index)} }
            >
              <MenuItem
                key={option.to}
                selected={selectedIndex === index}
                onClick={() => {
                  handleClose();
                  setTimeout(() => setSelectedIndex(index), 500)
                  //setSelectedIndex(index);
                }}
                className={classes.listItemButton}
                classes={{ selected: classes.listItemSelected }}
              >
                {option.name}
              </MenuItem>
            </LinkScroll>
          );
        })}
      </Popover>
    </div>
  );
}

const mapStateToProps = state => ({
  role: state.authClient.role,
  community: state.authClient.community,
  idLawFirm: state.authClient.idLawFirm,
});

export default connect(mapStateToProps, null)(TopNav);
